<template>
  <div class="main-container">
    <div class>
      <breadcrumb :list="breadcrumbList" />
      <tl-header type="h1">
        <div class="main-header">Bulk Payslips & IT Sheets</div>
      </tl-header>
      <br />

      <toast-message :message="errmsg" type="error" :isToastEnable="toast" @close="(val) => toast = val" />
      <div class="permission-alert-msg" v-show="!ifTeamleaderAnchorPermission && (role !== 'EMPLOYEE' && role !== 'HR')">
        You have only view permission.
      </div>
      <div class="row margintop-10 content-new">
        <div>
          <tl-radio  name="docType" label="Payslip" id="paySlip" value="paySlip" @change="docTypeChange"
            v-model="docType" />
        </div>
        <div>
          <tl-radio  name="docType" label="IT Sheet" id="ITSheet" value="ITSheet" @change="docTypeChange"
            v-model="docType" />
        </div>
        <div>
          <tl-radio  name="docType" label="Additional Sheet" id="additional_paySlip" value="additional_paySlip" @change="docTypeChange"
            v-model="docType" />
        </div>
      </div>
      <div class="row margintop-10 content-new">
        <div>
          <tl-radio  name="employeeStatus" label="Active Employees" id="active" value="active" 
            v-model="employeeStatus" />
        </div>
        <div>
          <tl-radio  name="employeeStatus" label="In-Active Employees" id="inActive" value="inActive"
            v-model="employeeStatus" />
        </div>
      </div>
      <section class="filters">
        <date-picker class="customwidth" :initialView="'month'" :formatDate="'MMMM-yyyy'" :maximumView="'year'"
          :minimumView="'month'" :datesDisabled="{ from: new Date(new Date().setDate(new Date().getDate() - 1)) }"
          @datevalue="(val) => getFormattedMonth(val)" :value="month" />
      </section>

      <div class="row margin-t-m" :disabled="!ifTeamleaderAnchorPermission" v-show="(role !== 'EMPLOYEE' && role !== 'HR')">
        <div class="dropDownClass">
          <!-- <tl-select class="tl-select" label="Paygroup" labelText="name" v-model="paygroup" :multiple="true" :options="paygroupOptions"
            @change="(val) => paygroup = val" /> -->
            <tl-select class="tl-select" label="Category" labelText="name" v-model="category" :multiple="false" :options="categoryOptions"
            @change="(val) => categoryFunction(val)" />
            <tl-select v-show="subCategoryVisibleFlag" class="tl-select" label="sub-category" labelText="name" v-model="subCategory" :multiple="true" :options="subCategoryOptions"
            @change="(val) => subCategoryFunction(val)" />
            
        </div>
        <div class="col-3 filterButton">
          <btn text="Generate" type="primary" class="btn-filter" @click="downloadBulkPayslips()"></btn>
          <pop-up-message v-if="showModal" :message="responseMessage" btnText="OK"
            @back="downloadBulkPayslipsdetails()"></pop-up-message>
        </div>
      </div>
      <p class="refresh-text">Please Refresh the Screen to View the Latest Status</p>
      <div class="table-div" ref="table_div" @scroll="onScroll()">
        <data-table :columns="columnNames" :tableData="bulkPayslipData" :showinrow="false">
          <template v-slot:rowcontent="slotprops">
            <div v-if="slotprops.value.column.key == 'download'">
              <button v-if="slotprops.value.record.status !== 'Initiated'"  class="export-button" 
              @click="downloadBulkPayslipsdata(slotprops.value.record)">download</button>
              <div class="reportDownloadRight" v-if="slotprops.value.record.status == 'Initiated'">
              <div @mouseover="downloadBulkPayslipsdetails()"class="loader-container">
                                    <div class="loader"></div>
                                </div>
                              </div>
            </div>
          </template>
        </data-table>
      </div>
    </div>
    <!-- PL_2996 -->

    <bottom-action-container>
      <btn-grp slot="end">
        <btn text="Back" type="secondary" class v-on:click="back"></btn>
      </btn-grp>
    </bottom-action-container>

    <!-- Payslip preview modal -->
    <div class="modal custom-modal" v-if="showCreateModal">
      <div class="modal-content modal-sm payslip-modal">
        <div class="modal-header">
          <h3>Payslip Preview</h3>
        </div>
        <div class="modal-body content-center">
          <div>
            <img src="@/assets/preview.png" />
          </div>
          <div class="download-btn">
            <div class="download-btn-container row download-content">
              <div class="rigth-margin-10">
                <img src="@/assets/download.svg" class="img" />
                <span class="text">Download Payslip</span>
              </div>
              <div class="rigth-margin-10">
                <img src="@/assets/download.svg" class="img" />
                <span class="text">Send to Email</span>
              </div>
              <div class="rigth-margin-10">
                <img src="@/assets/download.svg" class="img" />
                <span class="text">Send to ESS</span>
              </div>
              <btn-grp slot="end">
                <btn class="cancel-btn" text="Cancel" type="secondary" v-on:click="cancelPreviewDownload"></btn>
              </btn-grp>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapGetters, mapActions } from "vuex";
import SearchDropdown from "@/components/TlSearchDropdown.vue";
import {
  criteriaObj,
  monthOptionsObj
} from "../../../../../../../apis/constants.js";
const crypto = require("crypto");
export default {
  components: {
    SearchDropdown
  },

  data() {
    return {
      errmsg: "",
      categoryOptions:["Department","Location","Cost Centre","Designation","Grade"],
      subCategoryOptions:[],
      subCategory:[],
      subCategoryVisibleFlag:false,
      category:[],
      arrayStoredWithAllCatagoryList:{},
      responseMessage: "",
      docType: "paySlip",
      employeeStatus:'active',
      toast: false,
      showModal: false,
      selectedRecordsList: [],
      month: "",
      currentMonth: 0,
      filterType: {
        month: null,
        legalEntity: null,
        department: null,
        location: null,
        costCenter: null,
        designation: null
      },
      searchText: "",
      selectedFilterData: {},
      monthOptions: monthOptionsObj.monthListForFinancialYear.sort(
        (a, b) => a.index - b.index
      ),
      selectedArray: [],
      customEmpList: [],
      showDropdown: false,
      showinheader: false,
      showCreateModal: false,
      subCriteriaLabel: "",
      subcriteria: [],
      paygroup: "",
      criteria: "",
      paygroupOptions: [],
      subCriteriaList: [],
      criteriaOptions: criteriaObj.reportCriteria,
      paySlipMonth: "",
      paySlipYear: "",
      showDownloadableContent: false,
      showSendEmailContent: false,
      showSendESSContent: false,
      toast: false,
      monthValue: null,
      errmsg: "",
      sort: "Recently Joined",
      clientCode: "",
      conditions:{
        location: [],
        grade: [],
        designation: [],
        department: [],
        costCenter: [],
        employees_status : ""
      },
      columnNames: [
        // {
        //   label: "",
        //   key: "imgSrc"
        // },
        {
          label: "Month",
          key: "month"
        },
        {
          label: "Year",
          key: "year"
        },
        {
          label: "Status",
          key: "status"
        },
        {
          label: "Category",
          key: "catagoryName"
        },
        {
          label: "Sub-Catagory",
          key:"subCategoryName"
        },
        {
          label: "Document Type",
          key: "doc_type"
        },
        {
          label: "Download",
          key: "download"
        },
      ],
      bulkPayslipData: [],
      employeeList: [],
      search: "",
      page: 1,
      totalEmployees: 0,
      breadcrumbList: [
        {
          name: "Organisation",
          url: `/dashboard/${this.$route.params.entity_index}/organisation`
        },
        {
          name: "Utilities",
          url: `/dashboard/${this.$route.params.entity_index}/organisation/utilities`
        },
        {
          name: "Bulk Payslips",
          url: ""
        }
      ],
      paySlipsItSheetsValue: false,
      role: "",
      roleId: "",
      newPayslipMonth: null,
      legalEntityName: null,
    };
  },

  mounted() {
    // this.getEmployeeData();
    this.fetchBulkCatagoryList()
  },

  computed: {
    ...mapGetters({
      getLegalEntityId: "onboard/legal_entities/legal_entity_ID"
    }),
    ...mapState("onboard/organization", {
      orgId: state => state.id,
    }),
    ...mapState({
      payrollMonth: state => state.payroll.runpayroll.payrollMonth,
      payrollYear: state => state.payroll.runpayroll.payrollYear,
      entities: state => state.onboard.legal_entities.data
    }),
    leId() {
      if (this.$route.params.entity_index) {
        return this.getLegalEntityId(this.$route.params.entity_index);
      } else {
        return this.getLegalEntityId(0);
      }
    },
    ...mapState("onboard/organization", {
      orgIds: state => state.id
    }),
    ifTeamleaderAnchorPermission() {
      if (this.role === 'TEAMLEADER' || this.role === 'ANCHOR' || this.role === 'ADMIN') {
        if (this.paySlipsItSheetsValue) {
          return true;
        } else {
          return false;
        }
      }
      // else {
      //   return true
      // }
    }
  },

  activated() {
    this.page = 1;
    this.refresh();
    this.getPaygroups();
    this.getCurrentMonth();
    this.downloadBulkPayslipsdetails();
    this.getOrgLeIdList();
    // this.getEmployeeData();
  },
  methods: {
    ...mapActions({
      fetchEmployeeByName: "globalapi/globalemployees/fetchByLeAndName", // PL_2996
      fetchEmployees: "dashboard/payroll/reports/Reports/fetchAll",
      downloadpayslip:
        "dashboard/organisation/utilities/itsheetandpayslip/downloadPayslip",
      itsheet:
        "dashboard/organisation/utilities/itsheetandpayslip/downloadITSheet",
      fetch_paygroups: "onboard/paygroup/fetchAll",
      fetch_locations: "onboard/locations/fetchAll",
      fetch_grades: "onboard/salary_grades/fetchAll",
      fetch_bands: "onboard/salary_bands/fetchAll",
      fetch_departments: "onboard/departments/fetchAll",
      fetch_cost_center: "onboard/cost_centres/fetchAll",
      fetch_designation: "onboard/designations/fetchAll",
      act_download_new_payslip: "dashboard/organisation/utilities/itsheetandpayslip/downloadNewPayslips",
      act_download_new_itSheet: "dashboard/organisation/utilities/itsheetandpayslip/downloadNewItsheet",
      act_bulk_payslip: "dashboard/organisation/utilities/itsheetandpayslip/downloadBulkPayslips",
      act_bulk_payslip_details: "dashboard/organisation/utilities/itsheetandpayslip/downloadBulkPayslipsdetails",
      act_bulk_payslip_data: "dashboard/organisation/utilities/itsheetandpayslip/downloadBulkPayslipsdata",
      act_download_YTD_report: "dashboard/organisation/utilities/itsheetandpayslip/downloadYtdsheet",
      act_getProfileData: 'dashboard/payroll/monthlypayroll/employeeProfile/fetchAll',
      act_post_emp_details: "dashboard/organisation/utilities/itsheetandpayslip/postEmpDetails",
      act_get_bulk_catogory:"dashboard/itProof/fetchBulkPayslipSubCatagoryList",
      act_get_bulk_payslip_catogory:"dashboard/itProof/fetchBulkPayslipCatagory"
    }),

    // headerCheckboxChecked() {
    //   this.showinheader = false;
    // },
    async fetchBulkCatagoryList(){
      try{
        //console.log("this.leId",this.leId)
      let res = await this.act_get_bulk_catogory({"le_id":this.leId})
      //console.log("res.data.data",res.data)
      this.arrayStoredWithAllCatagoryList = res.data
      }catch(err){
        throw err
      }
    },
    subCategoryFunction(val){
      if (val.length > 5) {
        this.subCategory = val.slice(0, 5);
        this.toast = true;
        this.errmsg = "You can select a maximum of 5 sub categories.";
      } else {
        this.subCategory = val;
      }
    },
    categoryFunction(val){
      this.category = [val]
      this.subCategoryOptions = []
      this.subCategory = []
      //console.log("this.arrayStoredWithAllCatagoryList",this.arrayStoredWithAllCatagoryList)
      this.category.map(ele=>{
        if(ele == "All"){
          this.category = []
          this.category.push("All")
          this.subCategoryVisibleFlag = false
        }else if(!this.category.includes('All')){
          //console.log("ele",ele)
          this.subCategoryVisibleFlag = true
          if(ele =="Department"){
          this.arrayStoredWithAllCatagoryList['department_name'].map(ele=>{
            this.subCategoryOptions.push(ele)
          })
        } else if(ele =="Location"){
          this.arrayStoredWithAllCatagoryList['based_location_name'].map(ele=>{
            this.subCategoryOptions.push(ele)
          })
        } if(ele =="Cost Centre"){
          this.arrayStoredWithAllCatagoryList['cost_center_name'].map(ele=>{
            this.subCategoryOptions.push(ele)
          })
        } if(ele =="Designation"){
          this.arrayStoredWithAllCatagoryList['designation_name'].map(ele=>{
            this.subCategoryOptions.push(ele)
          })
        } if(ele =="Grade"){
          this.arrayStoredWithAllCatagoryList['grade_name'].map(ele=>{
            this.subCategoryOptions.push(ele)
          })
        }
      }
      })
      //console.log("subCategory",this.subCategory)
        
    },
    /* function to get fiancial year */
    getFormattedMonth(val) {
      try {
        this.paySlipMonth = this.monthOptions[new Date(val).getMonth()].name;
        this.monthValue = this.monthOptions[new Date(val).getMonth()].value;
        this.paySlipYear = new Date(val).getFullYear(); // PL_2664
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /* function get current month */
    getCurrentMonth() {
      try {
        this.month = this.payrollMonth ? this.payrollMonth + "-" + this.payrollYear : new Date();
        var today = new Date();
        this.currentMonth = today.getMonth();
        // this.getFormattedMonth(today);
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    docTypeChange() {
      this.downloadBulkPayslipsdetails();
    },

    /* function to refresh the page */
    refresh() {
      try {
        this.paygroup = [];
        this.criteria = null;
        this.subcriteria = [];
        this.subCriteriaList = []; // PL_2996
        this.employeeList = [];
        this.subCriteriaLabel = null; // PL_2996
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    getMonthName(month) {
      try {
        switch (month) {
          case "jan":
            this.newPayslipMonth = "January";
            break;
          case "feb":
            this.newPayslipMonth = "February";
            break;
          case "mar":
            this.newPayslipMonth = "March";
            break;
          case "apr":
            this.newPayslipMonth = "April";
            break;
          case "may":
            this.newPayslipMonth = "May";
            break;
          case "jun":
            this.newPayslipMonth = "June";
            break;
          case "jul":
            this.newPayslipMonth = "July";
            break;
          case "aug":
            this.newPayslipMonth = "August";
            break;
          case "sep":
            this.newPayslipMonth = "September";
            break;
          case "oct":
            this.newPayslipMonth = "October";
            break;
          case "nov":
            this.newPayslipMonth = "November";
            break;
          case "dec":
            this.newPayslipMonth = "December";
            break;
          default:
            break;
        }
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },

    async encryptData(payload) {
      try {
        const iv = crypto.randomBytes(8).toString('hex')
        const key = process.env.VUE_APP_PAYSLIP_SECRET;
        const cipher = crypto.createCipheriv('aes-256-cbc', key, iv);
        let encryptedText = Buffer.concat([
          cipher.update(JSON.stringify(payload)),
          cipher.final()
        ]);
        return {
          iv: iv.toString(),
          encryptedPacket: encryptedText.toString('base64')
        }
      } catch (err) {
        throw err;
      }
    },

    async decrypt(payload) {
      try {
        const key = process.env.VUE_APP_PAYSLIP_SECRET;
        const decipher = crypto.createDecipheriv('aes-256-cbc', key, payload.iv);
        const decrypted = Buffer.concat([decipher.update(payload.encryptedPacket, 'base64'), decipher.final()]);
        return decrypted.toString();
      } catch (error) {

      }
    },

    getLegalEntityName(value) {
      this.entities.map(item => {
        if (value == item.id) {
          this.legalEntityName = item.legalName;
          this.clientCode = item.clientCode;
        }
      })
    },
    segrigadeAllTheCondions(){
      this.conditions = {
        location: [],
        grade: [],
        designation: [],
        department: [],
        costCenter: [],
        employees_status: this.employeeStatus,
      }
      this.category.map(ele=>{
          //console.log("ele",ele,this.subCategory)
          if(ele =="Department"){
            let array =[]
            if(this.subCategory.length ==0){
              //console.log("this.subCategory.length is zero",this.subCategory)
              this.arrayStoredWithAllCatagoryList['department_name'].map(ele=>{
            let res = this.subCategoryOptions.includes(ele)
               if(res){
                array.push(ele)
               }
             this.conditions.department = array
            })
            }else if(this.subCategory.length > 0){
               //console.log("this.subCategory.length",this.subCategory)
              this.arrayStoredWithAllCatagoryList['department_name'].map(ele=>{
              let res = this.subCategory.includes(ele)
              //console.log("Ressssss",res)
               if(res){
                array.push(ele)
               }
             this.conditions.department = array
          })
            }
        
        } else if(ele =="Location"){
          let array =[]
          if(this.subCategory.length ==0){
            this.arrayStoredWithAllCatagoryList['based_location_name'].map(ele=>{
            let res = this.subCategoryOptions.includes(ele)
               if(res){
                array.push(ele)
               }
             this.conditions.location = array
          })
            }else if(this.subCategory.length > 0){
              this.arrayStoredWithAllCatagoryList['based_location_name'].map(ele=>{
            let res = this.subCategory.includes(ele)
               if(res){
                array.push(ele)
               }
             this.conditions.location = array
          })
            }
        } if(ele =="Cost Centre"){
          let array =[]
          if(this.subCategory.length ==0){
            this.arrayStoredWithAllCatagoryList['cost_center_name'].map(ele=>{
            let res = this.subCategoryOptions.includes(ele)
               if(res){
                array.push(ele)
               }
             this.conditions.costCenter = array
          })
            }else if(this.subCategory.length > 0){
              this.arrayStoredWithAllCatagoryList['cost_center_name'].map(ele=>{
            let res = this.subCategory.includes(ele)
               if(res){
                array.push(ele)
               }
             this.conditions.costCenter = array
          })
            }
        
        } if(ele =="Designation"){
          let array =[]
          if(this.subCategory.length ==0){
            this.arrayStoredWithAllCatagoryList['designation_name'].map(ele=>{
            let res = this.subCategoryOptions.includes(ele)
               if(res){
                array.push(ele)
               }
             this.conditions.designation = array
          })
            }else if(this.subCategory.length > 0){
              this.arrayStoredWithAllCatagoryList['designation_name'].map(ele=>{
            let res = this.subCategory.includes(ele)
               if(res){
                array.push(ele)
               }
             this.conditions.designation = array
          })
            }
         
        } if(ele =="Grade"){
          let array =[]
          if(this.subCategory.length ==0){
            this.arrayStoredWithAllCatagoryList['grade_name'].map(ele=>{
            let res = this.subCategoryOptions.includes(ele)
               if(res){
                array.push(ele)
               }
             this.conditions.grade = array
          })
            }else if(this.subCategory.length > 0){
              this.arrayStoredWithAllCatagoryList['grade_name'].map(ele=>{
            let res = this.subCategory.includes(ele)
               if(res){
                array.push(ele)
               }
             this.conditions.grade = array
          })
            }
        }
      })
    },
    async downloadBulkPayslips() {
      try {
        await this.getLegalEntityName(this.leId);
          if(this.category.length > 0){
            if (this.subCategory.length === 0) {
              this.toast = true;
              this.errmsg = "Please select at least one sub category.";
              return;
            }
        await this.segrigadeAllTheCondions()
          let obj = {
            legalEntityId:this.leId ,
            year: this.paySlipYear,
            leid: this.leId,
            month: this.paySlipMonth,
            client_name: this.legalEntityName,
            client_code: this.clientCode,
            doc_type: this.docType,
            conditions: this.conditions
          }
          let data = await this.encryptData(obj);
          let res = await this.act_get_bulk_payslip_catogory(data)
          let apiResponse = JSON.parse(await this.decrypt(res.data));
          //console.log("apiResponse",apiResponse)
           this.showModal = true; //PL-2010
           this.responseMessage = apiResponse.message;
      }
      else if(this.category.length == 0){
        this.toast = true;
        this.errmsg = "Please Select Catagory";
      }

      } catch (error) {
        this.toast = true;
        this.errmsg = "Details not Fetched";
      }
    },

    async downloadBulkPayslipsdetails() {
      try {
        this.showModal = false;
        await this.getLegalEntityName(this.leId);
        let obj = {
          legalEntityId: this.leId,
          "limit": 10,
          "page": 1
        }
        let data = await this.encryptData(obj);
        let res = await this.act_bulk_payslip_details(data);
        let apiResponse = JSON.parse(await this.decrypt(res.data))
        if (apiResponse.data.data) {
          this.bulkPayslipData = apiResponse.data.data
          this.bulkPayslipData.map((res) => {
            let catagoryName
            let subCategoryName = []
            for (let i in res.conditions) {
              if (res.conditions[i].length) {
                if (i != "employees_status") {
                  catagoryName = i[0].toUpperCase() + i.slice(1).toLowerCase()
                  subCategoryName = res.conditions[i]
                }
              }
            }
            res.catagoryName = catagoryName
            subCategoryName.forEach((word, index, arr) => {
              arr[index] = word[0].toUpperCase() + word.slice(1).toLowerCase()
            })
            res.subCategoryName = subCategoryName.join(", ")

          })
          this.bulkPayslipData.forEach(obj => {
            if (obj.doc_type === "paySlip") {
              obj.doc_type = "Payslip";
            } else {
              obj.doc_type = "IT Sheet";
            }
            if(obj.status === "INITIATED"){
              obj.status = "Initiated"
            }
            else{
              obj.status = "Completed" 
            }
          });
        }

      } catch (error) {
        this.toast = true;
        this.errmsg = "Details not Fetched";
      }
    },

    async downloadBulkPayslipsdata(item) {
      try {
        let obj = {
          id: item.id,
        }
        let data = await this.encryptData(obj);
        let res = await this.act_bulk_payslip_data(data);
        let apiResponse = JSON.parse(await this.decrypt(res.data));
        const url = apiResponse.data.pdfPreSignedUrl;
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "");
        document.body.appendChild(link);
        link.click();
      }

      catch (error) {
        this.toast = true;
        this.errmsg = "Details not Fetched";
      }
    },

    getMonthName(month) {
      try {
        switch (month) {
          case "jan":
            this.newPayslipMonth = "January";
            break;
          case "feb":
            this.newPayslipMonth = "February";
            break;
          case "mar":
            this.newPayslipMonth = "March";
            break;
          case "apr":
            this.newPayslipMonth = "April";
            break;
          case "may":
            this.newPayslipMonth = "May";
            break;
          case "jun":
            this.newPayslipMonth = "June";
            break;
          case "jul":
            this.newPayslipMonth = "July";
            break;
          case "aug":
            this.newPayslipMonth = "August";
            break;
          case "sep":
            this.newPayslipMonth = "September";
            break;
          case "oct":
            this.newPayslipMonth = "October";
            break;
          case "nov":
            this.newPayslipMonth = "November";
            break;
          case "dec":
            this.newPayslipMonth = "December";
            break;
          default:
            break;
        }
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },


    async getEmployeeData() {
      try {
        let bodyParams = {};
        let data = await this.getOrgLeList({
          data: {
            ...bodyParams
          }
        });
        this.role = data.data.user.userRole;
        this.employee_id = data.data.user.employee_id;
        let obj = {
          'employee_id': this.employee_id
        };
        let response = await this.act_getProfileData(obj);
        this.employeeData = response.data.payload[0];
        this.employeeData.dob = new Date(this.employeeData.dob).toISOString().slice(0, 10);
        this.employeeData.date_of_joining = (new Date(this.employeeData.date_of_joining).toLocaleString().slice(0, 10)).split("/").join("-");
        // this.postLock();
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },

    async getPaygroups() {
      try {
        let res = await this.fetch_paygroups(this.leId);
        if (res.data.status) {
          this.paygroupOptions = res.data.payload.data;
          this.paygroup = this.paygroupOptions[0];
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    back() {
      this.$router.push({
        path: `/dashboard/${this.$route.params.entity_index}/organisation/utilities`
      });
    },

    ...mapActions({
      getOrgLeList: "onboard/organization/getOrgLeIdList",
    }),

    async getOrgLeIdList() {
      const org = this.orgIds;
      const le = this.leId;
      let bodyParams = {};
      let data = await this.getOrgLeList({
        data: {
          ...bodyParams
        }
      });
      this.role = data.data.user.userRole;
      this.roleId = data.data.user.employee_id;
      this.paySlipsItSheetsValue = data.data.user.permissions.payslips_it_sheets ? true : false;
    },


  }
};
</script>
  
<style lang="scss" scoped>
.fnfbtn {
  width: 135px;
  align-self: flex-start;
  background-color: #ffffff;
  border: #34c0be solid 1px;
  color: #34c0be;
  font-weight: bold;
  padding: 10px 10px;
  border-radius: 4px;
}

.content-new {
  margin-bottom: 20px;
}

.filterButton {
  display: flex;
  align-items: center;
  padding: 0;
  margin-top:13px;
}

.refresh-text{
  margin-top: 30px;
  font-weight: bold;
}

.table-div {
  height: 250px;
  overflow: auto;
  margin-top: 10px;
}

.attachment {
  font-size: 14px;
  margin-top: -24px;
}

.text-right {
  text-align: center;
}

.checkbox-content {
  &:not(:last-child) {
    margin-bottom: 10px;
  }
}

.noBorder-btn {
  border: none !important;
  min-height: 0px !important;
  padding: 0px !important;
}

.content {
  margin-left: 20px;
  margin-top: 15px;
}

.main-header {
  color: #6d6d6d;
  margin-top: 25px;
  font-size: 16px;
}

.sort-by {
  display: flex;
  margin-left: 8%;

  span {
    margin-right: 10px;
    margin-top: 10px;
    color: #b3b3b3;
    font-size: 12px;
  }
}

.searchsort {
  display: flex;
  align-items: center;
  width: 100%;
  padding-right: 10px;

  .sorttext {
    text-align: center;
    line-height: 30px;
    color: #726f75;
    padding: 0px 0px 0px 10px;
    margin-left: auto;
  }
}

.customwidth {
  width: 200px;
  margin-top: 0px;
}

.atch-img {
  width: 2%;
}

.download-btn-container {
  display: flex;
  align-items: flex-end;

  .img {
    width: 16px;
    object-fit: contain;
  }

  .text {
    font-size: 10px;
    color: #34c0be;
    margin-left: 5px;
  }
}

.download-btn {
  margin-top: 2%;
}

.file-name {
  padding: 0px 5px;
}

.rigth-margin-10 {
  margin-right: 10px;
}

.content-center {
  justify-content: center;
  text-align: center;
}

.employeeDownload {
  margin-top: 20px;
  box-shadow: rgba(0, 0, 0, 0.05) 0px 6px 24px 0px, rgba(5, 5, 5, 0.08) 0px 0px 0px 1px;
  border-radius: 2%;
  width: max-content;
  padding: 10px;
  cursor: pointer;
}

.downloadImg {
  margin-right: 10px;
}

.downloadText {
  color: #34c0be;
  font-weight: bold;
}

.download-content {
  justify-content: flex-end !important;
  text-align: center;
  align-items: center !important;
}

.attach-content {
  color: #6e6e6e !important;

  a {
    margin-left: 4px;
    margin-right: 15px;
    font-size: 14px;
    position: relative;
    top: -6px;
  }
}

.font-size-14 {
  font-size: 14px !important;
}

// table header designs
.tableheader {
  display: flex;
  align-items: center;

  .action-dropdown {
    display: block;
    cursor: pointer;
    opacity: 0.1;
    position: relative;
  }

  &:hover {
    .action-dropdown {
      opacity: 1;
    }
  }
}

// try
.action-container {
  position: absolute;
  display: flex;
}

.action-menu {
  width: 175px;
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.23);
  background-color: #ffffff;
  margin-right: 10px;
  z-index: 1;
  padding: 20px 10px;
  position: absolute;
  top: 144%;
  padding-bottom: 10px;

  &::before {
    content: "";
    position: absolute;
    width: 0;
    height: 0;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    top: -10px;
    right: 30%;
    filter: drop-shadow(1mm 0mm 0mm rgba(0, 0, 0, 0.23));
  }

  &#download {
    margin-left: 0px;
  }

  &#email {
    margin-left: 100px;
  }

  &#ess {
    margin-left: 200px;
  }

  .edit {
    cursor: pointer;
    margin-left: 5px;
    font-size: 12px;
    color: #616363;
    margin-bottom: 10px;
  }

  .query {
    cursor: pointer;
    margin-left: 3px;
    font-size: 12px;
    color: #616363;
  }

  .joining {
    cursor: pointer;
    margin-left: 2px;
    font-size: 12px;
    color: #616363;
  }

  .dropdown-footer {
    border-top: 1px solid #d6d4d4;
  }
}

.export-button {
  padding: 0px 5px !important;
  margin: 0px 5px !important;
  width: 100px !important;
  margin-top: -5px !important;
}

.action-section {
  margin: 0px;
  text-align: center;

  img {
    width: auto;
  }

  .action-menu {
    top: 0%;
    left: -140%;
    width: max-content;
    padding-top: 5px;
    padding-bottom: 5px;

    li {
      padding: 0px;
      font-weight: 500;

      span {
        margin: 0px 20px;
        padding: 10px;
        display: block;
      }

      &:not(:last-child) {
        span {
          border-bottom: solid 1px #97979759;
        }
      }
    }
  }
}

.payslip-modal {
  width: 60% !important;
  height: 90% !important;
  margin: 60px auto 0px auto !important;
}

.cancel-btn {
  display: block;
  border-radius: 4px;
  background-color: #ffffff;
  border: #34c0be solid 1px;
  color: #34c0be;
  font-weight: bold;
  min-width: 60px;
  padding: 14px;
  font-size: 14px;
}

.permission-alert-msg {
  background-color: #f8d7da;
  padding: 1rem 1rem;
  margin-top: 1rem;
  margin-bottom: 1rem;
  font-weight: 600;
  color: #842029;
  border: 1px solid transparent;
  border-radius: .25rem;
  border-color: #f5c2c7;
}

.downLoadBtn {
  display: flex;
  gap: 20px
}

.export-button {
  background-color: rgba(14, 165, 235, 0.5);
  color: black;
  width: 6rem;
  height: 2rem;
}
.dropDownClass{
  display:flex;
}
.tl-select{
    width:400px;   
  }
  .reportDownloadRight {
    display: flex;
    align-items: center;
    gap: 10px;
    background-color:#ffffff;
    border: #34c0be solid 1px;
    color: #ffffff;
    border-radius: 4px;
    font-weight: bold;
    max-width: 135px;
    //max-height: 30px;
    text-align: center;
    padding: 5px 10px;
    margin-top: 6px;
    cursor: pointer;
    margin-right: 20px;
}
.loader-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
  
}

.loader {
  border: 2px solid #f3f3f3;
  border-top: 3px solid #34c0be;
  border-radius: 50%;
  width: 22px;
  height: 22px;
  animation: spin 1s linear infinite;
  
}
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
.styleReport{
padding: 5px 52px 5px 10px !important;
}
.export-button {
  background-color: rgba(14, 165, 235, 0.5);
  color: black;
  width: 6rem;
  height: 2rem;
  padding: 0px 5px !important;
  margin: 0px 5px !important;
  width: 100px !important;
  margin-top: -5px !important;
}
</style>
  